// libs
import React, { memo } from 'react';

// styles
import { Title, Text, Container, Pipe } from './styles';

// components
import UrgencyNudgeCoachMark from 'shared/components/UrgencyNudgeCoachMark';
import RenderIfVisible from 'shared/components/RenderIfVisible';

//defs
interface PromotionTextProps {
  promotionTextConfig: {
    pipeColor?: string;
    textColor: string;
    text: string;
  };
  className?: string;
  showUrgencyCoachMark: boolean;
}

function PromotionText({
  promotionTextConfig,
  className = '',
  showUrgencyCoachMark,
}: PromotionTextProps) {
  return (
    <Container className={className} data-test="promotion-text">
      {promotionTextConfig?.pipeColor && <Pipe color={promotionTextConfig.pipeColor} />}
      <Title>
        <Text color={promotionTextConfig?.textColor}>{promotionTextConfig?.text}</Text>
      </Title>
      {showUrgencyCoachMark && (
        <RenderIfVisible visibleOffsetTop={-48} visibleOffesetBottom={0} stayRendered>
          <UrgencyNudgeCoachMark />
        </RenderIfVisible>
      )}
    </Container>
  );
}

export default memo(PromotionText);
